import { COLORS } from '@/components/ui/ui.constants';

export const PILL_COLORS = {
  blue: '#2C7BB6',
  green: COLORS['dark-green'],
  grey: COLORS['tci-black'],
  orange: '#D87B1F',
  pink: '#C1497B',
  purple: '#522E91',
  red: '#B44539',
  yellow: '#996900',
};

export const hexToRGBA = (hex : string, alpha = 1) => {
  let r = '0'; let g = '0'; let b = '0';
  if (hex.length === 4) {
    r = `0x${hex[1]}${hex[1]}`;
    g = `0x${hex[2]}${hex[2]}`;
    b = `0x${hex[3]}${hex[3]}`;
  } else if (hex.length === 7) {
    r = `0x${hex[1]}${hex[2]}`;
    g = `0x${hex[3]}${hex[4]}`;
    b = `0x${hex[5]}${hex[6]}`;
  }
  return `rgba(${+r}, ${+g}, ${+b}, ${alpha})`;
};
